import React from 'react';
import { styled } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';

const CustomDiv = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
});

export const LoadingContainer = () => {
    return (
        <CustomDiv>
            <CircularProgress />
        </CustomDiv>
    );
};